<template>
  <div class="input-page" :style="this.provide ? {background: 'linear-gradient(to bottom, #D7EDFE, #EDF7FF)'}: {}">
    <img :src="this.provide ? require('../../assets/ciba/auth-pic.jpg') : require('../../assets/images/authentication/auth-pic.png')" alt="">
    <h5>为保障您的财产安全，请您完成身份验证</h5>
    <p>（温馨提示：一个身份证只能验证一个微信号哦）</p>
    <div class="input-page-content">
      <auth-input class="content-input" placeholder="请输入姓名" type="name" @sendOut="receive" />
      <auth-input class="content-input" placeholder="请输入身份证号" type="id" @sendOut="receive" />
      <auth-input class="content-input" placeholder="请输入手机号" type="phone" @sendOut="receive" />
      <div class="content-input" style="display: table;">
        <auth-input style="float: left;" placeholder="验证码" type="code" width="348" @sendOut="receive" />
        <long-btn
          blue
          width="220"
          style="float: right;"
          :text="codeText"
          :canUse="codeText === '获取验证码'"
          @confirm="getCode"
        />
      </div>
      <p class="content-input-err" :class="{'showErr': showInputErr}">{{errMsg}}</p>
      <long-btn class="content-btn" text="下一步" :canUse="isComplete" @confirm="checkResult" :blue="this.provide && isComplete" />
    </div>
  </div>
</template>

<script>
import api from '@edu-fe/api'
import login from '@edu-fe/login'
import LongBtn from './LongBtn'
import AuthInput from './AuthInput'

const request = {
  verify: api.create('/my/promote/verify/check', {
    method: 'post'
  })
}

export default {
  name: 'InputPage',
  data () {
    return {
      name: '',
      id: '',
      phone: '',
      code: '',
      codeText: '获取验证码',
      errMsg: 'error',
      showInputErr: false
    }
  },
  props: {
    // 按钮文字信息
    placeholder: {
      type: String,
      default: '请输入相应信息',
    }
  },
  computed: {
    isComplete () {
      return !!this.name && !!this.id && !!this.phone && !!this.code
    },
    provide () {
      return this.$route.query.provide === 'ciba'
    }
  },
  components: {
    LongBtn,
    AuthInput
  },
  methods: {
    async getCode () {
      if (this.codeText !== '获取验证码') {
        return
      }
      if (this.checkPhone()){
        const { code } = await api.authentication.sendCode({ phone: this.phone })
        if (code === 1) {
          this.$toast.show({ message: '验证码发送成功' })
          let count = 60
          const timer = setInterval(() => {
            this.codeText = `(${count}s) 后重新发送`
            count--
            if (count <= 0) {
              this.codeText = '获取验证码'
              clearInterval(timer)
            }
          }, 1000)
        } else if (code === -2) {
          this.showErr('请先登录')
          setTimeout(() => {
            login.login()
          }, 1000)
        } else {
          this.showErr(`验证码发送失败 (code: ${code})`)
        }
      }
    },

    checkPhone () {
      if (!this.phone) {
        this.showErr('请填入手机号')
        return false
      }
      if (!/1\d{10}/.test(this.phone)) {
        this.showErr('请填入正确的手机号')
        return false
      }
      return true
    },

    async checkResult() {
      if (!this.name) {
        this.showErr('请正确填写姓名')
        return
      }
      const regId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regId.test(this.id)) {
        this.showErr('身份证号位数有误，请重新输入')
        return
      }
      if (!this.checkPhone()) {
        return
      }
      if (!/\d{4}/.test(this.code)) {
        this.showErr('验证码格式有误，请重新输入')
        return
      }

      try {
        const requestData = {
          userName: this.name,
          userIdentity: this.id,
          phone: this.phone,
          verification: this.code
        }
        const { code, msg } = await request.verify(requestData)

        if (code === 1) {
          this.$emit('next', requestData)
        }  else {
          this.showErr(msg)
        }
      } catch (e) {
        this.showErr('出错了, 请重试')
      }

      return // 老接口
      const data = await api.authentication.checkId(this.id)()
      switch (data.code) {
        case 1010:
          this.showErr('该身份证已经绑定其他微信号，请重新输入')
          break;
        case 1011:
          this.showErr('已上传过身份证，请直接提现')
          setTimeout(() => {
            this.$router.push('/money')
          }, 1000)
          break;
        case 1006:
          this.showErr('身份证审核中')
          break;
        case 105:
          this.showErr('已上传过身份证，可直接提现')
          setTimeout(() => {
            this.$router.push('/money')
          }, 1000)
          break;
        case 1008:
          this.showErr('身份证号不合法，请重新输入')
          break;
        case -2:
          this.showErr('请先登录')
          setTimeout(() => {
            login.login()
          }, 1000)
          break;
        default:
          this.$emit('next',{
            userName: this.name,
            userIdentity: this.id,
            phone: this.phone,
            verification: this.code
          })
          break;
      }

    },
    receive(content, type) {
      this.showInputErr = false
      this[type] = content
    },
    showErr(msg) {
      this.showInputErr = true
      this.errMsg = msg
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .input-page {
    width: 100%;
    min-height: 100vh;
    background-color: #FDF0E1;
    text-align: center;
    padding-bottom: use(36);
    box-sizing: border-box;
    >img {
      width: 100%;
    }

    >h5 {
      /* 为保障您的财产安全，请您完成身份验证: */
      font-family: PingFangSC-Regular;
      font-size: use(30);
      color: #493B2E;
      line-height: 1.5;
    }

    >p {
      /* （温馨提示：一个身份证只能验证一个微信号: */
      font-family: PingFangSC-Regular;
      font-size: use(24);
      color: #A88667;
      line-height: 1.8;
    }

    &-content {
      width: use(696);
      border-radius: use(10);
      overflow: hidden;
      box-shadow: 0 use(6) use(10) 0 rgba(#000, 0.05);
      background-color: #fff;
      margin: use(35) auto 0;
      padding: use(75) 0 use(39);
      .content {
        &-input {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: use(42);
          width: use(592);

          &-err {
            font-size: use(24);
            color: #F94141;
            margin-top: use(-16);
            visibility: hidden;
            &.showErr{
              visibility: visible;
            }
          }
        }
        &-btn{
          margin-top: use(25);
        }
      }
    }
  }
</style>
